import { VisitTemplate, VisitTemplateQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { visitTemplatesTranslationKeys } from '../translations';

type VisitTemplatesLoaderChildrenRenderProps = {
   templates: VisitTemplate[] | undefined;
   loading: boolean;
   refetch: PromiseVoidFunction;
};

type VisitTemplatesLoaderProps = {
   readonly children: (renderProps: VisitTemplatesLoaderChildrenRenderProps) => JSX.Element;
};

export const VisitTemplatesLoader = (props: VisitTemplatesLoaderProps): JSX.Element => {
   const {
      data: visitTemplates,
      fetching: visitTemplatesFetching,
      error: visitTemplatesError,
      refetch: refetchVisitTemplates,
   } = useCqrsSearch<VisitTemplate>(() => new VisitTemplateQuery());

   if (visitTemplatesError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={visitTemplatesTranslationKeys.templatesFetchError}
            displayIndicator
         />
      );
   }

   return (
      <>
         {visitTemplatesFetching ? <LoaderSpinner /> : null}
         {props.children({
            templates: visitTemplates,
            loading: visitTemplatesFetching,
            refetch: refetchVisitTemplates,
         })}
      </>
   );
};
